import { EmployeeAsyncSelect } from "components/EmployeeAsyncSelect/EmployeeAsyncSelect";
import React, { Component } from "react";
import {
    Grid,
    Row,
    Col,
    FormGroup,
    ControlLabel,
    FormControl,
} from "react-bootstrap";

import { createEmployeeRequest, editEmployeeRequest } from "../../api/employee";

import AddForm from "./AddForm.jsx";
import UpdateForm from "./UpdateForm.jsx";

class Pan extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedAction: "",
            employeeSelectOptions: [],
            selectedEmployeeId: "",
            successMessage: null,
            errorMessage: null,
            formErrors: null,
            loading: false,
        };
    }

    handleActionSelect = (e) => {
        const { target } = e;
        const { name, value } = target;
        this.setState({
            [name]: value,
            formErrors: null,
        });
        // if (name === "selectedAction" && value === "update") {
        //     employeeSelectOptionRequest(
        //         {},
        //         (result) => this.setState({ employeeSelectOptions: result }),
        //         (error) =>
        //             this.setState({ errorMessage: "There was an error" }),
        //     );
        // }
    };

    validate = (data) => {
        const {
            company,
            firstName,
            lastName,
            employeeType,
            employeeNumber,
            payrollClassification,
            department,
            position,
            locationArea,
            payLevel
        } = data;

        const errors = {};
        if (!company) {
            errors.company = true;
        }

        if (!firstName) {
            errors.firstName = true;
        }

        if (!lastName) {
            errors.lastName = true;
        }

        if (!employeeType) {
            errors.employeeType = true;
        }

        if (!employeeNumber) {
            errors.employeeNumber = true;
        }

        if (!payrollClassification) {
            errors.payrollClassification = true;
        }

        if (!payLevel) {
            errors.payLevel = true;
        }

        /*
    if(!ecolaNumber){
      errors.ecolaNumber = true;
    }

    if(!superior){
      errors.superior = true;
    }
    */

        if (!department) {
            errors.department = true;
        }

        if (!position) {
            errors.position = true;
        }

        if (!locationArea) {
            errors.locationArea = true;
        }

        /*
        if(!benefits){
        errors.benefits = true;
        }*/


        if (Object.keys(errors).length > 0) {
            this.setState({ formErrors: errors });
        } else {
            this.setState({ formErrors: null });
            this.save(data);
        }
    };

    save = (data) => {
        const { selectedAction, selectedEmployeeId } = this.state;

        this.setState({ loading: true });

        const isNewRecord = selectedAction === "add";

        if (isNewRecord) {
            console.log("1");
            createEmployeeRequest(
                data,
                (result) => this.saveSuccess(),
                (error) => this.saveFailure(),
            );
        } else {
            editEmployeeRequest(
                selectedEmployeeId,
                data,
                (result) => this.saveSuccess(result),
                (error) => this.saveFailure(error),
            );
        }
    };

    saveSuccess = (result) => {
        console.log(result);
        this.setState({
            errorMessage: null,
            successMessage: "Employee saved successfully",
            loading: false,
        });
        this.props.history.push("employees/list");
    };

    saveFailure = (error) => {
        console.log(error);
        this.setState({
            errorMessage: "There was an error saving employee",
            successMessage: null,
            loading: false,
        });
    };

    handleChange = (employeeValue) => {
        this.setState({ selectedEmployeeId: employeeValue.value });
    };

    render() {
        const {
            selectedAction,
            selectedEmployeeId,
            loading,
        } = this.state;
        return (
            <div className="content">
                <Grid fluid>
                    <Row>
                        <Col md={12}>
                            <FormGroup controlId="formControlsSelect">
                                <ControlLabel>Select Action</ControlLabel>
                                <FormControl
                                    onChange={this.handleActionSelect}
                                    componentClass="select"
                                    name="selectedAction"
                                    value={selectedAction}
                                >
                                    <option value="">Select</option>
                                    <option value="add">
                                        Add new employee
                                    </option>
                                    <option value="update">
                                        Update employee
                                    </option>
                                </FormControl>
                            </FormGroup>
                        </Col>
                    </Row>
                    {selectedAction === "add" && (
                        <AddForm
                            save={this.validate}
                            formErrors={this.state.formErrors}
                            loading={loading}
                        />
                    )}
                    {selectedAction === "update" && (
                        <Row>
                            <Col md={12}>
                                <FormGroup controlId="formControlsSelect">
                                    <ControlLabel>
                                        Select employee to update
                                    </ControlLabel>
                                    <EmployeeAsyncSelect
                                        onChange={this.handleChange}
                                    />
                                    {/* <FormControl
                                        onChange={this.handleActionSelect}
                                        componentClass="select"
                                        name="selectedEmployeeId"
                                        value={selectedEmployeeId}
                                    >
                                        <option value="">Select</option>
                                        {employeeSelectOptions.map((option) => {
                                            return (
                                                <option
                                                    key={option.value}
                                                    value={option.value}
                                                >
                                                    {option.label}
                                                </option>
                                            );
                                        })}
                                    </FormControl> */}
                                </FormGroup>
                            </Col>
                        </Row>
                    )}
                    {selectedAction === "update" && selectedEmployeeId && (
                        <UpdateForm
                            selectedEmployeeId={selectedEmployeeId}
                            save={this.validate}
                            formErrors={this.state.formErrors}
                            loading={loading}
                        />
                    )}
                </Grid>
            </div>
        );
    }
}

export default Pan;
